'use strict';

MxEnumPickerCtrl.$inject = ['$q', '$scope', 'mx.SolutionBuilderAgent.EntityService'];

export default function MxEnumPickerCtrl($q, $scope, mxEntityService) {
	var vm = this;
	var _filter, _entityClassName;

	vm.$onInit = function () {
		vm.items = null;
		_filter = vm.filter;
		_entityClassName = vm.entityClassName;

		Object.defineProperty(vm, 'filter', {
			get: function () {
				return _filter;
			},
			set: function (value) {
				_filter = value;
				reloadItems();
			},
		});

		Object.defineProperty(vm, 'entityClassName', {
			get: function () {
				return _entityClassName;
			},
			set: function (value) {
				if (_entityClassName !== value) {
					_entityClassName = value;
					reloadItems();
				}
			},
		});
	};

	async function reloadItems() {
		const items = await vm.loadItems();
		$scope.$evalAsync(() => {
			vm.items = items;
		});
	}

	function loadEnumeration() {
		let loadPromise = mxEntityService.getEnumerationValues(vm.entityClassName, vm.filter).then((items) => (loadPromise !== vm.lastLoadPromise ? vm.lastLoadPromise : items));

		vm.lastLoadPromise = loadPromise;
		return loadPromise;
	}

	vm.loadItems = async function () {
		if (!vm.entityClassName) {
			return [];
		}

		let items = await loadEnumeration();
		if (!items) {
			return [];
		}

		if (vm.showValue === 'true') {
			items = items.map(function (item) {
				return {
					DisplayString: item.DisplayString + ' (' + item.Value + ')',
					Value: item.Value,
				};
			});
		}

		if (!vm.model && vm.model !== 0 && vm.default !== undefined) {
			vm.model = vm.default;
		}

		return items;
	};
}

const commonPickerProperties = {
	entityClassName: '@',
	filter: '=?',
	ngRequired: '=?',
	required: '=?require',
	dropdownHtmlClass: '@',
};

const commonPickerTemplate =
	'data-name="{{vm.name}}" ' +
	'data-label="{{vm.label}}" ' +
	'data-hint="{{vm.hint}}" ' +
	'ng-model="vm.model" ' +
	'data-load-items="vm.loadItems" ' +
	'data-items="vm.items" ' +
	'data-no-label="vm.allowEmpty !== \'true\'" ' +
	'allow-empty="{{vm.allowEmpty}}" ' +
	'data-item-title-field="DisplayString" ' +
	'data-item-id-field="Value" ' +
	'data-disabled="vm.disabled" ' +
	'data-read-only="vm.readOnly" ' +
	'ng-required="(vm.required || vm.ngRequired) && !vm.disabled && !vm.readOnly" ' +
	'data-on-change="vm.onChange()" ' +
	'dropdown-html-class="{{::vm.dropdownHtmlClass}}"' +
	'custom-validation="vm.customValidation"';

angular.module('mx.SolutionBuilderAgent').directive('mxEnumPicker', function mxEnumPickerDirective() {
	var directive = new mx.components.FormControlBase(MxEnumPickerCtrl, null);

	directive.template = '<mx-select ' + commonPickerTemplate + '></mx-select>';

	angular.extend(directive.bindToController, commonPickerProperties);
	directive.bindToController.default = '=?';
	directive.bindToController.allowEmpty = '@';
	directive.require.mxServiceContext = '?^mxServiceContext';

	delete directive.link;

	return directive;
});

/**
 * @ngdoc directive
 * @name mx.components:mxMultiEnumPicker
 * @module mx.components
 * @restrict 'E'
 * @description
 * The mx-multi-enum-picker control is used to create a picker where user can select enums in multiple mode.
 *
 * The example below demonstrates some of the attributes you may use with the MultiEnumPicker control:
 * @param {string} entityClassName@ - SPS class where data should be loaded from.
 * @param {string} filter= - Expression to extract only specific records.
 * @param {string} required= - The required property sets or returns whether a mxMultiObjectPicker must be filled out before submitting a form.
 * @param {string} dropdownHtmlClass@ - This will be applied to the dropdown menu for styling.
 *
 * @usage <mx-multi-object-picker data-label="Object Picker" ng-model="vm.selectedUsers" data-entity-class-name="SPSUserClassBase"> </mx-multi-object-picker>
 */
angular.module('mx.SolutionBuilderAgent').directive('mxMultiEnumPicker', function mxMultiEnumPickerDirective() {
	var directive = new mx.components.FormControlBase(MxEnumPickerCtrl, null);

	directive.template = '<mx-multi-picker  data-separator-char="," ' + commonPickerTemplate + '></mx-multi-picker>';

	angular.extend(directive.bindToController, commonPickerProperties);
	directive.bindToController.showValue = '@';
	directive.require.mxServiceContext = '?^mxServiceContext';

	delete directive.link;

	return directive;
});
